























































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Typography from '@/components/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import TextField from '@/components/atoms/TextField/TextField.vue';
import Radio from '@/components/molecules/Radio/Radio.vue';
import TitleOnboarding from '@/components/molecules/TitleOnboarding/TitleOnboarding.vue';
import SingUpService from '@/api/SingupService';
import RegistrationService from '@/api/RegistrationService';
import eventBus from '@/utils/eventBus';
import { updateRegistration } from '@/utils/updateRegistration';
import { convertCoinsPurchaseRatioToPercent } from '@/utils/coinsHelper';

@Component({
  components: {
    Typography,
    FilledButton,
    TextField,
    Radio,
    TitleOnboarding
  }
})
export default class ManageRewards extends Vue {
  @Prop({ default: false }) readonly page?: boolean;
  coinPurchaseRatio: number | null = null;
  optionSelected: string = '';
  inputValue: string = '';
  loading: boolean = false;
  service = new SingUpService();
  registrationService = new RegistrationService();
  ratioLimitToShowIcon = 15;

  @Watch('optionSelected')
  onOption(newOption: string) {
    if (!isNaN(newOption as any)) {
      this.coinPurchaseRatio = Number(newOption);
    } else if (newOption === 'other') {
      this.coinPurchaseRatio = Number(this.inputValue);
      setTimeout(() => {
        const otherInputRef = this.$refs.otherInput as any;
        otherInputRef.$refs.input.focus();
      });
    }
  }

  @Watch('inputValue')
  onOtherInput(newInputValue: string) {
    if (!isNaN(newInputValue as any)) {
      this.coinPurchaseRatio = Number(newInputValue);
    }
  }

  get isValid() {
    return !!this.coinPurchaseRatio && !isNaN(this.coinPurchaseRatio);
  }

  itemScale() {
    let scale = 1;

    const itemLength = Number(this.coinPurchaseRatio);
    const HigherAmountThanRatio = itemLength > 10;
    const itemWidth = HigherAmountThanRatio ? 35 : 34;
    const itemHeight = HigherAmountThanRatio ? 35 : 34;
    const containerWidth = HigherAmountThanRatio ? 218 : 224;
    const containerHeight = HigherAmountThanRatio ? 68 : 75;
    const marginRight = 12;
    const marginBottom = 8;

    const itemArea = (itemWidth + marginRight) * (itemHeight + marginBottom);

    const itemTotalArea = itemArea * itemLength;
    const containerArea = containerWidth * containerHeight;

    if (itemTotalArea > containerArea) {
      scale = containerArea / itemTotalArea;
    }

    const newHeight = itemHeight * scale;

    return `
      height: ${newHeight}px;
    `;
  }

  async submit() {
    const data = {
      coinPurchaseRatio: this.coinPurchaseRatio,
      coinRewardPercentage: convertCoinsPurchaseRatioToPercent(
        this.coinPurchaseRatio || 0
      )
    };

    this.loading = true;

    const res = await this.service.setupRules(data);

    this.loading = false;
    if (res && res.status === 200) {
      this.$store.dispatch('business/SET_BUSINESS_INFO', {
        ...this.businessInfo,
        coinPurchaseRatio: res.data.coinPurchaseRatio,
        coinRewardPercentage: res.data.coinRewardPercentage
      });
      updateRegistration('manage-rewards');
      this.$emit('save', res.data);
      return;
    }
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get businessCurrency() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  get businessCurrencyName() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencyName;
  }

  onBusinessInfo(businessInfo: any) {
    if (!this.page && !Number(businessInfo.coinPurchaseRatio)) {
      this.coinPurchaseRatio = 10;
      this.optionSelected = '10';
    } else if (businessInfo && businessInfo.coinPurchaseRatio) {
      const coinPurchaseRatio = Number(businessInfo.coinPurchaseRatio);
      if (!Number(coinPurchaseRatio)) return;
      if ([8, 10, 15, 20].includes(coinPurchaseRatio)) {
        this.optionSelected = `${coinPurchaseRatio}`;
      } else {
        this.optionSelected = 'other';
        this.inputValue = `${coinPurchaseRatio}`;
      }
      this.coinPurchaseRatio = coinPurchaseRatio;
    }
  }

  mounted() {
    this.onBusinessInfo(this.businessInfo);
    eventBus.$on('setBusinessInfo', this.onBusinessInfo);
  }
}
